import { render, staticRenderFns } from "./ProductInfo.vue?vue&type=template&id=10bf782e&"
import script from "./ProductInfo.vue?vue&type=script&lang=ts&"
export * from "./ProductInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports